<template>
  <div class="product__configurator">
    <div class="product-configurator-items">
      <div class="badge badge-gray">
        Ihr Komplettset enthält
      </div>
      <div
        v-if="discountPercentage"
        class="badge badge-special"
      >
        Sie sparen {{ discountPercentage }}%
      </div>

      <div
        :class="{'product-configurator-item': true, 'first': isFirstOption(option) }"
        v-for="option in bundleOptions"
        :key="('bundleOption_' + option.option_id)"
        :option="option"
      >
        <div class="product-item-content" v-if="isFirstOption(option) && selectedOptionValue(option).product">
          <div class="product-item-image">
            <SfImage :src="getThumbnailForProduct(selectedOptionValue(option).product)" />
          </div>

          <div class="product-item-attributes">
            <span class="product-item-title">
              {{ getSelectedOptionQty(option) }} x {{ option.title }}
            </span>
          </div>

          <a
            href="#product-datasheet"
            class="product-item-info"
          >
            <img src="/assets/custom/icons/icon-info-dark.svg">
          </a>

          <div class="product-item-price">
            <a-product-base-price
              :regular="price.regular"
              :special="price.special"
              :factor="product.baseprice_product_amount"
              :unit="product.baseprice_product_unit"
            />
          </div>
        </div>

        <div class="product-item-content" v-else-if="selectedOptionValue(option).product">
          <div class="product-item-image">
            <SfImage :src="getThumbnailForProduct(selectedOptionValue(option).product)" />
          </div>

          <div class="product-item-attributes">
            <span class="product-item-title">
              + {{ getSelectedOptionQty(option) }} x {{ option.title }}
            </span>
            {{ selectedOptionValue(option).product.name }}
          </div>

          <a @click="viewDataSheet(selectedOptionValue(option).product)" class="product-item-info">
            <img src="/assets/custom/icons/icon-info-dark.svg">
          </a>

          <div class="product-item-change" v-if="option.product_links.length > 1 || !option.required">
            <a @click="scrollTo('#bundleOption_' + option.option_id)">ändern</a>
          </div>

          <div class="product-item-price" v-if="(selectedOptionValue(option).price > 0) || (selectedOptionValue(option).price === 0)">
            <a-product-base-price
              :regular="selectedOptionValue(option).price < selectedOptionValue(option).product.final_price_incl_tax.toFixed(2) ? selectedOptionValue(option).product.final_price_incl_tax.toFixed(2) : selectedOptionValue(option).price"
              :special="selectedOptionValue(option).price < selectedOptionValue(option).product.final_price_incl_tax.toFixed(2) ? selectedOptionValue(option).price : null"
              :factor="selectedOptionValue(option).product.baseprice_product_amount"
              :unit="selectedOptionValue(option).product.baseprice_product_unit"
            />
          </div>
          <div class="badge badge-free" v-else>
            kostenlos
          </div>
        </div>
      </div>
    </div>

    <div class="product-configurator-summary">
      <div class="product-configurator-summary__base-price-total">
        <div class="product__base-price">
          <span
            v-if="basePriceTotalOld > basePriceTotal"
            class="product__base-price__old"
          >
            <span class="unit">{{ basePriceTotalCurrency }}/{{ basePriceTotalUnit }}</span>
            <span class="price">{{ formatPrice(basePriceTotalOld).split(' ')[0] }}</span>
          </span>
          <span
            :class="[ basePriceTotalOld > basePriceTotal ? 'product__base-price__special' : 'product__base-price__regular' ]"
          >
            <span class="unit">{{ basePriceTotalCurrency }}/{{ basePriceTotalUnit }}</span>
            <span class="price">{{ formatPrice(basePriceTotal).split(' ')[0] }}</span>
          </span>
        </div>
      </div>

      <div class="product-configurator-summary__set-savings">
        <span>
          <span class="unit">{{ basePriceTotalCurrency }}/{{ basePriceTotalUnit }}</span>
          <span class="price">{{ formatPrice(basePriceTotalOld - basePriceTotal).split(' ')[0] }}</span>
          gespart
        </span>
      </div>
    </div>

    <div class="product-configurator-small-print">
      <div class="product-configurator-summary__set-total">
        <div class="product-configurator-summary-left">
          Preis pro Set
        </div>
        <div class="product-configurator-summary-right">
          <SfPrice
            :regular="regularPrice"
          />
        </div>
      </div>
      <div class="product-configurator-summary__set-contents">
        | Inhalt pro Set <strong>{{ setAmount }} {{ basePriceTotalUnit }}</strong>
      </div>

      <div class="taxes">
        Inkl. 19% MwSt., zzgl.
        <router-link :to="localizedRoute('/versandkosten')">
          Versand
        </router-link>
        <!--<a @click="viewShippingCosts">Versand</a>-->
      </div>
    </div>

    <!--div class="product-configurator-measures">
      <AProductQuantityCalculator
        @input="firstOptionQuantity = $event"
        unlimit-quantity
        v-if="firstOptionValue && firstOptionValue.product"
        :product="firstOptionValue.product"
      />
    </div-->
  </div>
</template>

<script>
import { getSelectedBundleOptions } from '@vue-storefront/core/modules/catalog/helpers/bundleOptions'
import { SfPrice, SfImage } from '@storefront-ui/vue';
import { price } from '@vue-storefront/core/filters/price'
import { basePriceUnit, scrollTo, discountPercentage } from 'theme/helpers/custom';
import AProductQuantityCalculator from 'theme/components/atoms/a-product-quantity-calculator'
import { getProductPrice } from 'theme/helpers'
import { mapGetters, mapActions } from 'vuex';
import { getThumbnailForProduct } from '@vue-storefront/core/modules/cart/helpers';
import { getSelectedBundleOptionValue, getBundleBasePriceTotal, getBundleBasePriceTotalOld } from 'theme/helpers/bundle';
import AProductBasePrice from 'theme/components/atoms/a-product-base-price'
import {
  mapMobileObserver,
  unMapMobileObserver
} from '@storefront-ui/vue/src/utilities/mobile-observer';

import { ModalList } from 'theme/store/ui/modals'

export default {
  name: 'MProductConfigurator',
  components: {
    SfPrice,
    SfImage,
    AProductQuantityCalculator,
    AProductBasePrice
  },
  data () {
    return {
      firstOptionQuantity: 1
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  watch: {
    firstOptionQuantity (newVal) {
      this.$parent.$refs.bundleOptions.$children[0].quantity = newVal
    }
  },
  computed: {
    ...mapGetters({
      getCurrentCustomOptions: 'product/getCurrentCustomOptions'
    }),
    firstOptionValue () {
      return this.selectedOptionValue(this.firstOption())
    },
    price () {
      return getProductPrice(this.product, this.customOptions)
    },
    regularPrice () {
      var total = null
      var qty = 1

      for (const option of this.bundleOptions) {
        if (total === null) { // first option uses bundle product price
          total = (this.price.special ? this.price.special : this.price.regular)
          qty = this.selectedOptionValue(option).qty
          total *= qty
          continue
        }

        if (!this.selectedOptionValue(option).product) {
          continue;
        }
        var optionPrice = this.selectedOptionValue(option).price;
        if (!isNaN(optionPrice)) {
          total = total + (optionPrice * this.selectedOptionValue(option).qty)
        }
      }
      return price(total / qty)
    },
    setAmount () {
      return this.firstOptionValue.product.baseprice_product_amount.toLocaleString('de-DE', { maximumFractionDigits: 3 })
    },
    bundleOptions () {
      return this.product.bundle_options.filter(o => this.selectedOptionValue(o))
    },
    basePriceTotalCurrency () {
      return price(this.selectedOptionValue(this.bundleOptions[0]).price).split(' ')[1]
    },
    basePriceTotalUnit () {
      var unit = this.selectedOptionValue(this.bundleOptions[0]).product.baseprice_product_unit;

      if (!isNaN(parseFloat(unit)) && isFinite(unit)) {
        return basePriceUnit(unit)
      }

      return unit
    },
    basePriceTotal () {
      return getBundleBasePriceTotal(this.product)
    },
    basePriceTotalOld () {
      return getBundleBasePriceTotalOld(this.product)
    },
    discountPercentage () {
      return discountPercentage(this.basePriceTotal, this.basePriceTotalOld)
    },
    ...mapMobileObserver()
  },
  beforeDestroy () {
    unMapMobileObserver();
  },
  methods: {
    ...mapActions('ui', {
      openModal: 'openModal'
    }),
    viewShippingCosts () {
      this.openModal({ name: ModalList.ShippingCosts, payload: this.product })
    },
    viewDataSheet (product) {
      this.openModal({ name: ModalList.DataSheet, payload: product })
    },
    getSelectedOptionQty (option) {
      let selected = getSelectedBundleOptions(this.product).find((o) => o.option_id === option.option_id)
      return (selected) ? selected.option_qty : '';
    },
    selectedOptionValue (option) {
      return getSelectedBundleOptionValue(this.product, option)
    },
    scrollTo (anchor) {
      return scrollTo(anchor)
    },
    isFirstOption (option) {
      return this.product.bundle_options.find(() => true).option_id === option.option_id
    },
    firstOption () {
      return this.product.bundle_options.find(() => true)
    },
    formatPrice (linkPrice) {
      return price(linkPrice)
    },
    selectedProduct (option) {
      const selected = this.selectedOptionValue(option)
      return selected && selected.product ? selected.product : null
    },
    getThumbnailForProduct (product) {
      if (!product) {
        return null
      }
      return getThumbnailForProduct(product);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
